import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { LoanRequestsTableDefinitionZod } from '../tables';

type Arguments = {
    id: string;
    position: number;
};
export const schemaLoanRequestResolver_GetLoanRequestStatusData = LoanRequestsTableDefinitionZod.pick({
    status: true,
    statusReason: true,
    subStatus: true,
}).nullable();

export type SchemaLoanRequestResolver_GetLoanRequestStatusData = z.infer<
    typeof schemaLoanRequestResolver_GetLoanRequestStatusData
>;

export type LoanRequestResolver_GetLoanRequestStatusData = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetLoanRequestStatusData
>;
